module.exports = __webpack_public_path__ + "img/featured-mobile-cta-2.dd06a0e1.jpg";